import { Box } from "@mui/material";
import { CustomerRequirements } from "../requirements/customerRequirements";
import { InputColor } from "../inputColors";
import { EvaluationResults } from "../evaluationResults";
//  This component handling the logic for which child component has to render according to activeStep state
export const StepContent = ({ activeStep }) => {
  return (
    <Box>
      {activeStep == 0 ? <CustomerRequirements /> : ""}
      {activeStep == 1 ? <InputColor /> : ""}
      {activeStep == 2 ? <EvaluationResults /> : ""}
    </Box>
  );
};
